import EmberChart from "ember-cli-chart/components/ember-chart";

export default EmberChart;
